var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScale1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#fff1dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 44,
    x2: 63,
    y2: 44,
    fill: "none",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.38,
    y1: 44,
    x2: 11.38,
    y2: 32,
    fill: "#fff8e1",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.69,
    y1: 44,
    x2: 21.69,
    y2: 32,
    fill: "#fff8e1",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 44,
    x2: 32,
    y2: 32,
    fill: "#fff8e1",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.31,
    y1: 44,
    x2: 42.31,
    y2: 32,
    fill: "#fff8e1",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.62,
    y1: 44,
    x2: 52.62,
    y2: 32,
    fill: "#fff8e1",
    stroke: "#fb8006",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.95 27.22 14.71 16.46 29.2 16.46 21.95 27.22",
    fill: "#fb8006"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale1);
export default __webpack_public_path__ + "static/media/scale_1.a3c1c0474c4cfbcded4804ab80a20dc0.svg";
export { ForwardRef as ReactComponent };